// extracted by mini-css-extract-plugin
module.exports = {"notifications":"styles_notifications__MEgfS","title":"styles_title__2Ya1k","switch":"styles_switch__2cctb"};